module.exports = __webpack_public_path__ + "static/media/btn-new-chat-enabled.f20cfefe.svg";